//SetupSlide.js
import React, { Component } from "react";
import { StyleSheet, css } from "aphrodite/no-important";
import Button from "@material-ui/core/Button";
import Snackbar from "components/Snackbar";
import FullPageLoader from "components/FullPageLoader";
import Server from "components/Server";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import Visibility from "@material-ui/icons/Visibility";
import Assignment from "@material-ui/icons/Assignment";
import TextField from "@material-ui/core/TextField";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Common from "./Common";
import Cache from "Cache";
import TopBar from "./TopBar";
import CircularProgress from '@material-ui/core/CircularProgress';

const styles = {
	root: {
		width: "100%",
		height: "100%",
		maxWidth: "100%",
		display: "flex",
		flexDirection: "column",
        alignItems: "center",
        justifyContent: "flex-start",
        minHeight: "400px",
    }
};
const className = StyleSheet.create({
    card: { 
        width: "100%", 
        maxWidth: "600px", 
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginTop: "10vh"
    },
    cardContent: {
        width: "100%",
		height: "100%",
        maxWidth: "100%",
        padding: "3% 15%",
        display: "flex",
        flexDirection: "column",
		alignItems: "center"
    },
    loginButton: {
        marginTop: "25px",
        maxWidth: "100%",
        width: "200px",
        height: "40px"
    },
	center: { display: "flex", justifyContent: "center" },
	heading: {
		fontSize: "1.3rem",
		fontWeight: "300"
	},
	margin: {
		margin: "5px"
	}
});

const loginSentences = [
    "We know you, we just need a proof.",
    "Remind us, who are you?",
    "You know the rules.",
    "Hey there, email and password please."
];

class Login extends Component {
	constructor(props) {
        super(props);
		this.state = {
			loginInProgress: false,
			emailInput: "",
            passwordInput: "",
        };

        this.loginSentence = this.GetRandomLoginSentence();
	}

	handleInputOnChange = name => event => {
		this.setState({
			[name]: event.target.value
		});
	};

	LoginOnClick = () => {
        if (this.ValidateLogin() == false) {
            Snackbar.error("Login failed. please make sure you filled email and password (at least 8 characters).");
            return;
        }
        this.setState({ loginInProgress: true });
        Server.post(
			"/login",
			{
                email: this.state.emailInput,
                password: this.state.passwordInput
			},
			this.loginDone, null, this.loginFailed
		);
    };
    
    loginDone = (res) => {
        if (res.data.auth === true)
            window.App.setState({ login: true });
        else
            Snackbar.error("Invaild email or password.");
    }

    loginFailed = (res) => {
        Snackbar.error("Invaild email or password.");
        this.setState({loginInProgress: false});
    }

    GetRandomLoginSentence = () => {
        const randomSentence = Math.floor(Math.random() * loginSentences.length);
        return loginSentences[randomSentence];
    }

	renderLoginCard() {
		return (
            <Card classes={{ root: css(className.card) }}>
                <CardContent classes={{ root: css(className.cardContent) }}>
                    <Typography
                        variant="h5"
                        color={"primary"}
                        gutterBottom
                    >
                        {this.loginSentence}
                    </Typography>
                            <TextField
                                inputRef={ref =>
                                    (this.emailInputRef = ref)
                                }
                                name="emailInput"
                                id="email"
                                type={"text"}
                                label={"Email"}
                                value={this.state.emailInput}
                                onChange={this.handleInputOnChange(
                                    "emailInput"
                                )}
                                margin="normal"
                                fullWidth
                                disabled={this.state.loginInProgress}
                                error={false}
                            />
                            <TextField
                                id="password"
                                type={"password"}
                                label={"Password"}
                                name="Password"
                                value={this.state.passwordInput}
                                onChange={this.handleInputOnChange(
                                    "passwordInput"
                                )}
                                margin="normal"
                                fullWidth
                                disabled={this.state.loginInProgress}
                                error={false}
                            />
                            <Button
                                classes={{ root: css(className.loginButton) }}
								variant="contained"
								color="secondary"
                                onClick={() => this.LoginOnClick()}
                                disabled={this.state.loginInProgress}
							>
								{this.state.loginInProgress && <div style={{position: "absolute", marginTop: "4px", left: "25px"}}>
                                    <CircularProgress color="white" size={22} />
                                </div>
                                }
                                login
							</Button>
                </CardContent>
            </Card>
		);
    }
    
    ValidateLogin = () => {
        let email = this.state.emailInput.trim();
        let password = this.state.passwordInput.trim();

        if (email.length > 5 
            && email.includes("@") 
            && email.includes(".")
            && password.length > 7)
            return true;
        return false;
    }

	render() {
		return (
			<div style={styles.root}>
				{this.renderLoginCard()}
			</div>
		);
    }
    
    onChange(value) {
        console.log("Captcha value:", value);
      }
}

export default Login;
